// THIS FILE IS GOING TO BE OVERWRITTEN ON BUILD SERVER
// BA Admin Port
var port = 8081

// useful to test from real mobile device while running dev server
var apiRoot = window.location.protocol + '//'+window.location.hostname + ':' + port

if (process.env.API_ROOT) {
  apiRoot = process.env.API_ROOT
}

// apiRoot = 'https://dev.admin.briteapps.com'
// apiRoot = 'http://localhost:8081'
// apiRoot = 'http://localhost'
if (window.DOCKER_API_ROOT) {
  apiRoot = window.DOCKER_API_ROOT
}


var config = {
  url: apiRoot
}
let tag = 'local'
if (window.DOCKER_IMAGE_TAG) {
  tag = window.DOCKER_IMAGE_TAG
}

config.DOCKER_IMAGE_TAG = tag

export default config
